import angular from 'angular';
import urlConfig from '../url-config/url-config';

import ApiActionDirective from './api-action-directive';

const apiAction = angular.module('apiAction', [urlConfig]);
apiAction.directive('apiAction', ApiActionDirective);

export default apiAction.name;
